import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { FadeUp, SectionShell } from "./Reveal";
import { STATES } from "../constants/site";

const Counter = ({ to, suffix = "", duration = 1.8 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, { duration, ease: [0.16, 1, 0.3, 1], onUpdate: (v) => setVal(Math.round(v)) });
    return () => controls.stop();
  }, [inView, to, duration]);
  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
};

export default function StatsBand() {
  return (
    <SectionShell id="stats" className="py-24 sm:py-32">
      <div className="relative overflow-hidden rounded-[2.5rem] border border-line bg-card px-6 sm:px-12 py-14 sm:py-20 shadow-soft">
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-bluze to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-torange to-transparent" />

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
          {[
            { testid: "stat-clients", value: <Counter to={90} suffix="+" />, label: "US CPA & accounting clients served" },
            { testid: "stat-states", value: <Counter to={12} />, label: "US states served across the country" },
            { testid: "stat-years", value: <Counter to={3} suffix="+" />, label: "Years of dedicated US KPO delivery" },
            { testid: "stat-timezones", value: "5/5", label: "US time zones covered — ET to PT" },
          ].map((s) => (
            <FadeUp key={s.testid} className="text-center lg:text-left">
              <p data-testid={s.testid} className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold text-gradient leading-none">
                {s.value}
              </p>
              <p className="mt-4 text-xs sm:text-sm text-slate-500 max-w-[220px] mx-auto lg:mx-0">{s.label}</p>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.2} className="mt-16">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400 text-center lg:text-left">Where our clients are</p>
          <div className="mt-5 flex flex-wrap justify-center lg:justify-start gap-2.5" data-testid="states-served-list">
            {STATES.map((st) => (
              <span key={st} className="rounded-full border border-line bg-paper px-4 py-2 text-xs font-semibold text-slate-600 hover:border-torange/50 hover:text-ink transition-colors duration-300 cursor-default">
                {st}
              </span>
            ))}
          </div>
        </FadeUp>
      </div>
    </SectionShell>
  );
}
